import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {Irsaliye} from '../model/irsaliye';
import {RestService} from '../providers/rest.service';

@Component({
  selector: 'app-irsaliye-liste',
  templateUrl: './irsaliye-liste.component.html',
  styleUrls: ['./irsaliye-liste.component.css']
})
export class IrsaliyeListeComponent implements OnInit {

  DURUM_OLUSTURULDU = Irsaliye.DURUM_OLUSTURULDU;

  irsaliyeler: Irsaliye[] = null;

  @Output() onayGuncelle = new EventEmitter<any>();
  @Output() updateList = new EventEmitter<boolean>();


  @Input()
  public set source(irsaliyeler: Irsaliye[]) {
    if (irsaliyeler != null) {
      this.irsaliyeler = irsaliyeler;
    }
  }

  constructor(private router: Router,
              private restService: RestService) {
  }

  ngOnInit(): void {
  }

  incele(t: Irsaliye) {
    this.router.navigate(['irsaliye'], {queryParams: {id: t.id}});
  }

  netsisAktar(id: number) {
    this.restService.netsisAktar(id).subscribe(res => {
      this.updateList.emit(true);
    });
  }
}
